/** Service Desk console: Board, listahan at detalye ng proyekto sa Installations (C09/C10, SD-S3-10). */
export const serviceInstallations = {
  subtitle: "Mga {{projectsLc}} ng fit-out at commissioning, {{stageLc}} por {{stageLc}}, kasama ang {{items}} at ang pagtanggap ng client na nagsisimula ng warranty.",
  orgTab: { emptyTitle: "Walang {{areaLc}}", emptyBody: "Lalabas dito ang {{projectsLc}} para sa bagong kagamitan.", meta: "Lead: {{lead}} · {{passed}} sa {{total}} ang pasado" },
  // Ang mga neutral na salita, gamit hanggang alam na ang bokabularyo ng workspace at kapag walang plural dito.
  words: { project: "Proyekto", projects: "Mga proyekto", stage: "Yugto", stages: "Mga yugto", openItems: "Mga bukas na item", area: "Mga Installation" },
  status: {
    planned: "Nakaplano",
    in_progress: "Isinasagawa",
    punch_list: "Tinatapos ang mga item",
    ready_for_acceptance: "Handa na para tanggapin",
    handed_over: "Naiturn-over na",
    on_hold: "Naka-hold",
    cancelled: "Kinansela",
  },
  actions: {
    create: "Bagong {{project}}",
    edit: "I-edit ang {{projectLc}}",
    start: "Simulan ang {{projectLc}}",
    startDone: "Nasimulan ang {{number}}",
    hold: "I-hold",
    resume: "Ituloy",
    resumeDone: "Naituloy ang {{number}}",
    cancel: "Kanselahin ang {{projectLc}}",
  },
  stats: {
    label: "Buod",
    active: "Aktibo",
    activeHint: "isinasagawa o nakaplano",
    punch: "{{items}}",
    punchHint: "{{projectsLc}} na tinatapos ang mga item",
    ready: "Handa na para tanggapin",
    readyHint: "naghihintay sa client",
    handedOver: "Naiturn-over na",
    handedOverHint: "tinanggap ng client",
  },
  filters: {
    view: "Tanaw",
    board: "Board",
    list: "Listahan",
    search: "Hanapin ang numero o pangalan",
    searchLabel: "Maghanap ng {{projectsLc}}",
    lead: "Lead",
    allLeads: "Lahat ng lead",
    statusGroup: "Status ng {{projectLc}}",
    chip: { all: "Lahat", active: "Aktibo", handed_over: "Naiturn-over na" },
  },
  board: {
    label: "{{projects}} ayon sa status",
    column: { planned: "Nakaplano", in_progress: "Isinasagawa", punch_list: "Tinatapos ang mga item", ready_for_acceptance: "Handa na para tanggapin", handed_over: "Naiturn-over na", paused: "Naka-hold o kinansela" },
    empty: "Walang {{projectLc}}",
    open: "Buksan ang {{number}} {{name}}",
    stages: "{{passed}} sa {{total}} ang pasado",
    progressLabel: "{{passed}} sa {{total}} {{stageLc}} ang pasado",
    items: "{{done}}/{{total}} {{items}}",
    noItems: "Walang {{items}}",
    late: "Lampas na sa planong pagtatapos",
  },
  list: {
    label: "{{area}}",
    organisation: "Organisasyon",
    lead: "Lead",
    plannedEnd: "Planong pagtatapos",
    status: "Status",
    verified: "{{done}}/{{total}} ang na-verify",
  },
  empty: {
    title: "Wala pang {{areaLc}}",
    body: "Magsimula ng {{projectLc}} para masubaybayan ang {{stagesLc}} nito, ang {{items}} at ang pagtanggap ng client.",
    filteredTitle: "Walang tumutugmang {{projectLc}}",
    filteredBody: "I-clear ang filter para makita ang lahat ng {{projectLc}}.",
  },
  error: { title: "Hindi ma-load ang {{areaLc}}", body: "Tingnan ang koneksyon mo at subukan ulit. Walang nabago." },
  errors: {
    notReady: "Hindi pa handa ang {{projectLc}} para tanggapin: may {{stageLc}} na hindi pa pasado o may item pang bukas.",
    closed: "Sarado na ang {{projectLc}} na ito at hindi na mababago.",
  },
  form: {
    createTitle: "Bagong {{project}}",
    createDescription: "Galing sa template ang {{stagesLc}}. Puwede lang magsimula ang isang {{stageLc}} kapag pasado na ang nauuna rito.",
    editTitle: "I-edit ang {{number}}",
    name: "Pangalan ng {{project}}",
    organisation: "Organisasyon",
    chooseOrganisation: "Pumili ng organisasyon",
    template: "Template",
    templateHint: "Ang {{stagesLc}} na pagdadaanan ng {{projectLc}}.",
    defaultTemplate: "Default ng workspace",
    site: "Site",
    noSite: "Walang site",
    lead: "Lead",
    noLead: "Walang lead",
    startOn: "Magsisimula",
    endOn: "Planong pagtatapos",
    warrantyMonths: "Warranty (buwan)",
    warrantyHint: "Binibilang mula sa pagtanggap ng client. Iwanang walang laman para gamitin ang sariling warranty ng bawat asset.",
    assets: "Mga asset sa {{projectLc}} na ito",
    assetsHint: "Mga kasalukuyang asset ng organisasyon. Puwedeng magdagdag pa mamaya.",
    description: "Paglalarawan",
    notes: "Mga tala",
    create: "Gumawa ng {{project}}",
    save: "I-save ang mga pagbabago",
    created: "Nagawa ang {{number}}",
    updated: "Na-save ang {{number}}",
  },
  validation: {
    organisation: "Piliin ang organisasyon para sa {{projectLc}} na ito.",
    name: "Bigyan ang {{projectLc}} ng pangalang hanggang {{max}} character.",
    dates: "Hindi puwedeng mas maaga ang planong pagtatapos kaysa sa simula.",
    months: "Maglagay ng buong bilang ng buwan mula 1 hanggang {{max}}.",
    text: "Hanggang {{max}} character lang.",
  },
  detail: {
    back: "{{area}}",
    loading: "Nilo-load ang {{projectLc}}",
    more: "Iba pang aksyon",
    notFoundTitle: "Hindi nahanap ang {{projectLc}}",
    notFoundBody: "Maaaring na-archive na ito. Bumalik sa listahan para hanapin.",
    tbc: "TBC",
    leadAndDates: "Lead: {{lead}} · {{start}} hanggang {{end}}",
    noLead: "hindi pa itinakda",
    statusReason: "Dahilan: {{reason}}",
  },
  actionDialog: {
    reason: "Dahilan",
    needsReason: "Sabihin kung bakit. Itinatago ang dahilan sa {{projectLc}}.",
    holdTitle: "I-hold ang {{number}}?",
    holdBody: "Titigil ang trabaho hangga't hindi mo itinutuloy. Walang mawawala.",
    holdConfirm: "I-hold",
    holdDone: "Naka-hold ang {{number}}",
    cancelTitle: "Kanselahin ang {{number}}?",
    cancelBody: "Hindi na maibabalik ang kinanselang {{projectLc}}. Nananatili ang mga asset at dokumento nito.",
    cancelConfirm: "Kanselahin ang {{projectLc}}",
    cancelDone: "Kinansela ang {{number}}",
  },
  stage: {
    title: "Progreso ng {{stage}}",
    order: "Sinusunod ang pagkakasunod-sunod: magsisimula lang ang isang {{stageLc}} kapag pasado na ang nauuna rito.",
    stepLabel: "{{n}}. {{label}}: {{status}}",
    status: { pending: "Naghihintay", in_progress: "Isinasagawa", passed: "Pasado", failed: "Bagsak" },
    parallel: "Puwedeng magsimula anumang oras",
    optional: "Opsyonal",
    started: "Nagsimula noong {{date}}",
    finished: "Natapos noong {{date}}",
    onAcceptance: "Ipinapasa ang {{stageLc}} na ito ng pagtanggap ng client.",
    checklist_one: "Checklist: {{open}} pa ang gagawin",
    checklist_other: "Checklist: {{open}} pa ang gagawin",
    action: { start: "Simulan ang {{stageLc}}", pass: "Markahang pasado ang {{label}}", fail: "Markahang bagsak", retest: "Subukan ulit", reopen: "Buksan ulit" },
    moved: { pending: "Naghihintay ulit ang {{label}}", in_progress: "Nagsimula ang {{label}}", passed: "Pasado ang {{label}}", failed: "Bagsak ang {{label}}" },
    blocked: {
      previous_not_passed: "Naka-block: hindi pa pasado ang nauunang {{stageLc}}.",
      later_stage_started: "Naka-block: nagsimula na ang mas huling {{stageLc}}.",
      checklist_incomplete: "Naka-block: tapusin muna ang checklist.",
      not_allowed: "Hindi puwedeng gumalaw ang {{stageLc}} na ito sa ganoong paraan.",
    },
  },
  punch: {
    status: { open: "Bukas", in_progress: "Isinasagawa", fixed: "Naghihintay ng verification", verified: "Na-verify", reopened: "Binuksan ulit", waived: "Hindi na kailangan" },
    filters: {
      group: "Status ng item",
      all: "Lahat",
      open: "Bukas",
      in_progress: "Isinasagawa",
      fixed: "Naghihintay ng verification",
      verified: "Na-verify",
      reopened: "Binuksan ulit",
      waived: "Hindi na kailangan",
      search: "Hanapin ang item o lokasyon",
      searchLabel: "Maghanap ng mga item",
      assignee: "Nakatalaga",
      allAssignees: "Lahat ng nakatalaga",
    },
    table: {
      label: "Mga item",
      selectAll: "Piliin ang lahat ng item",
      select: "Piliin ang {{number}}",
      item: "Item",
      location: "Lokasyon",
      asset: "Asset",
      assignee: "Nakatalaga",
      status: "Status",
      open: "Buksan ang {{number}} {{title}}",
      via: "mula sa",
      nonBlocking: "Hindi nakaharang",
    },
    emptyTitle: "Wala pang {{items}}",
    emptyBody: "Lalabas dito ang mga item na ginawa ng team o ng client.",
    emptyFilteredTitle: "Walang tumutugmang item",
    emptyFilteredBody: "I-clear ang filter para makita ang lahat ng item.",
    errorTitle: "Hindi ma-load ang mga item",
    errorBody: "Tingnan ang koneksyon mo at subukan ulit.",
    refused: {
      evidence_required: "Magdagdag ng after photo o tala bago markahang naayos ang item na ito.",
      reason_required: "Kailangan ng dahilan.",
      not_allowed: "Hindi puwede ang galaw na iyon mula sa kasalukuyang status ng item.",
      not_for_actor: "Ang team ng {{projectLc}} lang ang puwedeng gumawa niyon.",
    },
    add: {
      open: "Magdagdag ng item",
      title: "Magdagdag sa {{item}}",
      description: "Bagong item para sa {{number}}. Makikita ito ng client sa portal.",
      titleLabel: "Pamagat",
      location: "Lokasyon",
      asset: "Asset",
      noAsset: "Wala",
      assignee: "Nakatalaga",
      unassigned: "Walang nakatalaga",
      dueOn: "Due sa",
      descriptionLabel: "Paglalarawan",
      blocking: "Pumipigil na maging handa ang {{projectLc}}",
      blockingHint: "Dapat ma-verify o hindi na kailangan ang item bago matanggap ang {{projectLc}}.",
      save: "Idagdag ang item",
      added: "Naidagdag ang {{number}}",
      problems: { title: "Ilarawan ang item sa hanggang {{max}} character." },
    },
    move: {
      action: { start: "Simulan ang trabaho", fixed: "Markahang naayos", verify: "I-verify sa site", waive: "Hindi na kailangan", reopen: "Buksan ulit" },
      title: { fixed: "Markahang naayos", verify: "I-verify sa site", waive: "Hindi na kailangan ang item", reopen: "Buksan ulit ang item" },
      reason: { verify: "Dahilan", waive: "Dahilan kung bakit hindi na kailangan", reopen: "Dahilan" },
      note: "Tala",
      notePlaceholder: "Ano ang ginawa?",
      evidenceHint: "Kailangan ng tala o after photo para markahang naayos ang item.",
      save: "I-save",
      problems: { reason: "Magbigay ng dahilang hindi bababa sa {{min}} character.", evidence: "Magdagdag ng after photo o tala bago markahang naayos ang item na ito." },
      done: { start: "Isinasagawa ang {{number}}", fixed: "Naayos ang {{number}}", verify: "Na-verify ang {{number}}", waive: "Hindi na kailangan ang {{number}}", reopen: "Binuksan ulit ang {{number}}" },
    },
    bulk: {
      title: { verify: "I-verify sa site ang mga napiling item", waive: "Hindi na kailangan ang mga napiling item", reassign: "Italaga ulit ang mga napiling item" },
      description_one: "{{count}} item ang napili, {{eligible}} ang puwedeng baguhin.",
      description_other: "{{count}} item ang napili, {{eligible}} ang puwedeng baguhin.",
      action: { verify: "I-verify sa site", waive: "Hindi na kailangan", reassign: "Italaga ulit" },
      verifyHint: "Ang mga naayos lang ang puwedeng i-verify; lalaktawan ang iba.",
      reason: "Dahilan",
      assignTo: "Italaga kay",
      choose: "Pumili ng tao",
      apply: "Ilapat",
      problems: { assignee: "Piliin kung kanino mapupunta ang mga item." },
      done: { verify: "{{done}} sa {{total}} item ang na-verify", waive: "{{done}} sa {{total}} item ang hindi na kailangan", reassign: "{{done}} sa {{total}} item ang naitalaga ulit" },
    },
    drawer: {
      notFoundTitle: "Hindi nahanap ang item",
      notFoundBody: "Maaaring natanggal na ito sa listahan.",
      awaiting: "Naayos na, naghihintay ng verification ng client o ng lead ng {{projectLc}} na may dahilang \"na-verify sa site\".",
      waived: "Hindi na kailangan: {{reason}}",
      verified: "Na-verify: {{reason}}",
      location: "Lokasyon",
      asset: "Asset",
      raisedBy: "Ginawa ni",
      actor: { staff: "Ang team", contact: "Ang client" },
      ticket: "Pinagmulang ticket",
      assignee: "Nakatalaga",
      dueOn: "Due sa",
      blocking: "Pumipigil sa pagtanggap",
      blockingYes: "Oo",
      blockingNo: "Hindi",
      reopened: "Beses na binuksan ulit",
      fixNote: "Ano ang ginawa",
      photos: "Mga larawan",
      update: "I-update",
      readOnly: "Ang team ng {{projectLc}} lang ang puwedeng magbago ng item. Read-only na ngayon ang {{projectLc}} na ito.",
      previous: "Nauna",
      next: "Susunod",
    },
    photos: {
      before: "Bago",
      after: "Pagkatapos",
      none: "Walang larawang {{phase}}",
      add: "Magdagdag ng larawang {{phase}}",
      added: "Naidagdag ang larawan",
      remove: "Alisin ang {{name}}",
      unavailable: "Hindi available ang larawan",
    },
  },
  acceptance: {
    title: "Pagtanggap",
    chip: { blocked: "Naka-block", ready: "Handa na para tanggapin", awaiting: "Naghihintay sa client", accepted: "Naiturn-over na", paused: "Naka-hold", cancelled: "Kinansela" },
    headline: {
      blocked: "Hindi pa handa para tanggapin.",
      ready: "Handa na para tanggapin.",
      awaiting: "Naghihintay sa client.",
      accepted: "Tinanggap at pinirmahan.",
      paused: "Naka-hold.",
      cancelled: "Kinansela.",
    },
    body: {
      blocked: "Tapusin muna ang mga nasa ibaba.",
      ready: "Na-verify o hindi na kailangan ang bawat item at pasado ang bawat {{stageLc}}. Markahang handa ang {{projectLc}} para makapirma ang client.",
      awaiting: "Puwede nang mag-sign in sa portal ang organisation admin ng client.",
      accepted: "Nagsimula na ang warranty ng bawat asset.",
      paused: "Ituloy ang {{projectLc}} para magpatuloy.",
      cancelled: "Hindi matatanggap ang kinanselang {{projectLc}}.",
    },
    requirements: "Ang kailangan pa",
    itemsDone: "Na-verify o hindi na kailangan ang lahat ng {{items}}",
    toGo_one: "{{count}} na lang",
    toGo_other: "{{count}} na lang",
    stagesPassed: "Pasado ang bawat {{stage}}",
    notPassed: "Hindi pasado: {{names}}",
    who: "Pumipirma ang organisation admin ng client matapos maglagay ng isang beses na code. Sinisimulan ng pagtanggap ang warranty ng bawat asset.",
    markReady: "Markahang handa para tanggapin",
    markedReady: "Handa nang tanggapin ng client ang {{number}}",
    notReadyToast: "Hindi pa handa: tapusin ang mga item at {{stagesLc}} na nakalista sa itaas.",
    certificate: "Sertipiko ng pagtanggap",
    preview: "I-preview ang sertipiko",
    certificateSaved: "Na-save bilang PDF ang sertipiko",
    previewSaved: "Na-save bilang PDF ang preview. Gagawin ang pinal na sertipiko kapag pumirma ang client.",
    signedBy: "Pinirmahan ni",
    signedAt: "Pinirmahan",
    comments: "Mga komento",
    noRecord: "Hindi available ang tala ng pagtanggap.",
  },
  assets: {
    title: "Mga asset sa {{project}} na ito",
    asset: "Asset",
    accepted: "Tinanggap",
    awaiting: "Naghihintay ng pagtanggap",
    unlink: "Alisin ang {{tag}} sa {{projectLc}} na ito",
    pick: "Magdagdag ng asset",
    pickPlaceholder: "Pumili ng asset na idadagdag",
    link: "Idagdag ang asset",
    linked: "Naidagdag ang asset sa {{projectLc}}",
    emptyTitle: "Wala pang nakarehistrong asset",
    emptyBody: "Lalabas dito ang mga asset kapag naihatid at natagan na ang kagamitan.",
  },
  documents: {
    addTitle: "Magdagdag ng dokumento ng {{projectLc}}",
    kinds: { report: "Ulat", drawing: "Guhit", manual: "Manual", certificate: "Sertipiko", photo: "Larawan", other: "Iba pa" },
    emptyTitle: "Wala pang dokumento",
    emptyBody: "Dito ilalagay ang mga ulat ng {{stageLc}}, as-built na guhit at manual.",
  },
} as const;
